<template>
  <div>
    <SearchableTable
      :panel-header="'Schulen/Kindergarten'"
      :panel-route="'AddSchool'"
      :show-search-bar="true"
      :table-data="filteredSchools"
      :table-meta-data="tableMetaData"
      :query-string="'setSchoolSearchQuery'"
      :initial-search-query="schoolSearchQuery"
      :row-click="triggerView"
      :default-sort="['attributes.name', 'asc']"
    />
  </div>
</template>

<script>
import { queryLocationByType } from "@/lib/Query";
import { mapGetters } from "vuex";
import SearchableTable from "../helperComponents/SearchableTable.vue";

export default {
	name: "SchoolsComponent",
	components: { SearchableTable },
	data() {
		return {
			schools: [],
			tableMetaData: [
				{ "id": 0, "type": "string", "label": "Name", "field": "name", "sortField": "attributes.name" },
				{ "id": 1, "type": "string", "label": "Email", "field": "email", "sortField": "attributes.email" },
				{ "id": 2, "type": "string", "label": "Ort", "field": "location", "sortField": "attributes.location" }
			]
		}
	},
	computed: {
		...mapGetters({
			schoolSearchQuery: "getSchoolSearchQuery"
		}),
		filteredSchools() {
			const query = this.schoolSearchQuery.toLowerCase();
			if (!query) return this.schools;
			return this.schools.filter(school => {
				const a = school.attributes;
				return [ a.name, a.email, a.location ].some(value =>
					value && value.toLowerCase().includes(query));
			});
		}
	},
	async created() {
		this.schools = await queryLocationByType("school")
	},
	methods: {
		triggerView(school) {
			this.$router.push(
				{ name: "ViewSchool", params: { id: school.id, data: school } });
		}
	}
}
</script>

<style scoped></style>
